import { ForeignNational, GetNationalHookQuery } from 'API';
import { getNationalHook } from 'graphql/customQueries';
import { useEffect, useState } from 'react';
import { client } from 'lib/graphql-client';
import { GraphQLResult } from '@aws-amplify/api';

const useGetForeignNational = (
  foreignNationalID?: string | null,
): ForeignNational | undefined => {
  const [
    national, setNational] = useState(undefined as ForeignNational | undefined);
  useEffect(() => {
    let ignore = false;

    const getNational = async () => {
      const response = (await client.graphql({
        query: getNationalHook,
        variables: {
          id: foreignNationalID,
        },
      })) as GraphQLResult<GetNationalHookQuery>;

      if (!ignore && response.data?.getForeignNational) {
        setNational(
          response.data.getForeignNational as ForeignNational,
        );
      }
    };

    if (foreignNationalID) {
      getNational();
    } else {
      setNational(undefined);
    }

    return () => {
      ignore = true;
    };
  }, [foreignNationalID]);

  return national;
};

export default useGetForeignNational;
